export const reportsDateFilterKey = 'reports_date_filter';
export const reportsRefreshStateKey = 'reports_refresh_state';
export const reportsFullGraphKey = 'full_graph';
export const reportsActionTypeKey = 'actionTypeFilter';
// The volume-filter param, defined once in `~/shared/utils/filterUrlParams` and re-exported
// here so existing `apiFilterKey` importers keep working.
export { apiFiltersParamKey as apiFilterKey } from '~/shared/utils/filterUrlParams';
